import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ICourse } from "../../../Pages/Subject/ICourse";

export const DeleteCourseSlice = createSlice({
  name: "DeleteCourse",
  initialState: {} as IReduxState<ICourse>,
  reducers: {
    deleteCourse: (state, _) => {
      state.isLoading = true;
    },
    successdeleteCourse: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failuredeleteCourse: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearDeleteCourseResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  deleteCourse,
  failuredeleteCourse,
  successdeleteCourse,
  clearDeleteCourseResponse,
} = DeleteCourseSlice.actions;

export default DeleteCourseSlice.reducer;
